import React from 'react'
import clsx from 'clsx'

export const CloseIcon = ({ className }: { className?: string }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    className={clsx('icon', 'icon_large', className)}
  >
    <polygon
      fillRule='evenodd'
      points='12 10.609 18.609 4 20 5.391 13.391 12 20 18.609 18.609 20 12 13.391 5.391 20 4 18.609 10.609 12 4 5.391 5.391 4'
      fill='currentColor'
    ></polygon>
  </svg>
)
